import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Input } from "antd";
import { useAxios } from "../helpers/apiHelper";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { saveUserToStorage, updateLoadingStatus } from "../redux/actions/sharedActions";
import { useHistory } from "react-router-dom";
import { useGlobalConst } from "../helpers/constData";

const Login = () => {
   const axios = useAxios();
   const dispatch = useDispatch();
   const history = useHistory();
   const globalConst = useGlobalConst();

   const [formLogin] = Form.useForm();

   const usrRef = useRef(null);

   function GetRandomString(t) {
      for (var n = "", o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = o.length, r = 0; r < t; r++) n += o.charAt(Math.floor(Math.random() * e));
      return n;
   }

   const onFinish = async (values) => {
      if (!values.usname && values.usname === undefined) {
         Swal.fire({
            text: "Tên đăng nhập không được để trống !",
            icon: "error",
            confirmButtonText: "OK",
         });

         usrRef.current.focus();
      } else {
         var t = values.pw.trim(),
            a = GetRandomString(11),
            o = GetRandomString(13),
            n = btoa(a + t + o);

         const formData = new FormData();
         formData.append("usname", values.usname);
         formData.append("pw", n);

         updateLoadingStatus(dispatch, true);

         try {
            const response = await axios.post(`/do-login`, formData);

            if (response && response.status === 200 && response.data.success) {
               const _user = {
                  userName: values.usname,
                  token: response.data.token,
               };

               updateLoadingStatus(dispatch, false);
               saveUserToStorage(_user);
               dispatch({ type: "SetUser", payload: _user });
               history.push(localStorage.getItem("pathLocation") ?? "/banggia/vn30");
            } else {
               updateLoadingStatus(dispatch, false);
               formLogin.resetFields();
               Swal.fire({
                  text: "Đăng nhập thất bại ! Số tài khoản hoặc mật khẩu không đúng !",
                  icon: "error",
                  confirmButtonText: "OK",
               });
            }
         } catch (error) {
            updateLoadingStatus(dispatch, false);
            formLogin.resetFields();

            Swal.fire({
               text: "Đăng nhập thất bại ! Số tài khoản hoặc mật khẩu không đúng !",
               icon: "error",
               confirmButtonText: "OK",
            });
         }
      }
   };
   useEffect(() => {
      // Check if inputs have values (either from autofill or local storage)
      const inputs = document.querySelectorAll("input");
      inputs.forEach((input) => {
         if (input.value !== "") {
            // Add a class to the parent form-field to trigger the label positioning
            input.closest(".form-field").classList.add("has-value");
         }
      });
   }, []);
   return (
      <div className="login">
         <div className="login__wrap">
            <div className="row login__body">
               <div className="col-md-6 login__infor">
                  <div className="login__logo">
                     <img src="/static/img/logo_tvsi_2.svg" alt="logo" />
                  </div>

                  <h2>
                     bảng giá pricevip
                     <br /> dành cho khách hàng
                     <br /> của tvsi
                  </h2>
                  <div className="login__txt">
                     Quý khách vui lòng đăng nhập bằng số tài khoản và <br />
                     mật khẩu của iTrade-Home
                  </div>

                  <div className="login__register">
                     <span>
                        Bạn chưa có tài khoản? <a href="https://www.tvsi.com.vn/help-open-account.html">Đăng ký ngay</a>
                     </span>
                  </div>
               </div>

               <div className="col-md-6 login__form">
                  <h2>Đăng nhập hệ thống</h2>

                  <Form form={formLogin} onFinish={onFinish}>
                     <Form.Item label="Tài khoản" name="usname" className="form-field">
                        <Input ref={usrRef} type="text" placeholder="Tài khoản" />
                     </Form.Item>

                     <Form.Item label="Password" name="pw" className="form-field">
                        <Input type="password" placeholder="Mật khẩu" />
                     </Form.Item>

                     <Button className="login__btn" htmlType="submit">
                        ĐĂNG NHẬP
                     </Button>
                  </Form>

                  <div className="login__txt m-0">Qúy khách vui lòng sử dụng trình duyệt Chrome phiên bản mới nhất để trải nghiệm tốt hơn.</div>
               </div>
            </div>

            <div className="login__foot">
               <div className="line">
                  <div className="line-white"></div>
                  <div className="line-red"></div>
               </div>
               <div className="login__social">
                  <div className="item">
                     <img src="/static/img/icon/ic_map_tvsi.png" alt="icon" />
                     <div>Địa chỉ: Tầng 17, Tòa nhà VCCI Tower, Số 9 Đào Duy Anh, P.Kim Liên, TP.Hà Nội.</div>
                  </div>

                  <div className="item">
                     <img src="/static/img/icon/ic_phone_tvsi.png" alt="icon" />
                     <div>Hotline: 1900 1885 </div>
                  </div>

                  <div className="item">
                     <img src="/static/img/icon/ic_mail_tvsi.png" alt="icon" />
                     <div>Email: contact@tvsi.com.vn</div>
                  </div>
               </div>

               <div className="login__copyright">
                  <div className="copyright">© Công ty cổ phần Chứng khoán Tân Việt (TVSI)</div>

                  <div className="develope-by">
                     <a target="_blank" rel="noopener noreferrer" href="https://navisoft.com.vn/">
                        Phát triển bởi Navisoft
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Login;
